const API_URL = import.meta.env.VITE_API_URL;

export async function apiFetch(path, token, options) {
  const response = await fetch(`${API_URL}${path}`, {
    method: options?.method || 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options?.body ? { 'Content-Type': 'application/json' } : {}),
    },
    body: options?.body ? JSON.stringify(options.body) : undefined,
  });

  if (!response.ok) {
    const text = await response.text();
    let message;
    try {
      message = JSON.parse(text).message;
    } catch {
      message = text;
    }
    throw new Error(message || `Request failed: ${response.status}`);
  }

  return response.json();
}
